import { Reveal } from "./Reveal";

export const ChapterHeading = ({ label, title, sub, align = "left" }) => (
    <Reveal className={`mb-12 lg:mb-16 ${align === "center" ? "text-center" : ""}`}>
        <p
            className={`font-jbmono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4 flex items-center gap-3 ${
                align === "center" ? "justify-center" : ""
            }`}
        >
            <span className="inline-block h-px w-8 bg-[#F5C518]/70" aria-hidden="true" />
            {label}
            {align === "center" && (
                <span className="inline-block h-px w-8 bg-[#F5C518]/70" aria-hidden="true" />
            )}
        </p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-3xl mx-auto">
            {title}
        </h2>
        {sub && (
            <p className={`mt-4 text-sm sm:text-base text-slate-400 max-w-2xl leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>
                {sub}
            </p>
        )}
        <div className={`mt-6 h-px w-24 bg-gradient-to-r from-[#F5C518] to-transparent ${align === "center" ? "mx-auto bg-gradient-to-r from-transparent via-[#F5C518] to-transparent" : ""}`} />
    </Reveal>
);
